import ClientProvider from "context/admin/client";
import ClientDetails from "page_components/admin/clients/Details";

const Client = () => (
  <ClientProvider>
    <ClientDetails />
  </ClientProvider>
);

export default Client;
